import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQ } from "@/data/site";

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-24 sm:py-32 bg-ink-800/40">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <div className="text-center mb-14">
          <h4 className="text-xs uppercase tracking-[0.3em] text-gold-500 font-sans mb-5">
            Domande frequenti
          </h4>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-white leading-tight">
            Tutto quello che vuoi sapere
            <br />
            <span className="italic text-gray-400">prima di iniziare.</span>
          </h2>
        </div>

        <div className="space-y-3">
          {FAQ.map((f, i) => {
            const active = open === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-white/10 bg-ink-800 overflow-hidden"
              >
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(active ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-medium text-white">{f.q}</span>
                  <span className="shrink-0 text-gold-500">
                    {active ? <Minus size={20} /> : <Plus size={20} />}
                  </span>
                </button>
                <AnimatePresence>
                  {active && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-6 text-sm leading-relaxed text-gray-400">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
